const DATA_ZAP_HASH = 'datazap'

export default DATA_ZAP_HASH
